module.exports = function isSSR() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement)
}
